export default __webpack_public_path__ + "static/media/GGGL.53c703e7.png";